<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-24
    	描述：后台母版
    -->
  <div :class="hasChild != null ? 'main' : 'main right-big'">
    <!--left menu-->
    <LeftMenu @selectMenu="selectMenuFunc"></LeftMenu>

    <!--right content-->
    <RightContent></RightContent>
  </div>
</template>

<script>
import LeftMenu from '@/views/layout/LeftMenu.vue'
import RightContent from '@/views/layout/RightContent.vue'
import store from '@/store/'
import bus from '@/utils/eventBus.js'

export default {
  components: {
    /*左菜单组件*/
    LeftMenu,
    /*右边内容容器*/
    RightContent
  },
  data () {
    return {
      /*是否有子菜单*/
      hasChild: null,
      /*系统基本数据*/
      baseInfo: {
        shop_name: '',
        user: {},
        version: '',
        wxQrCode: '',
        wxUrlLink: '',
        storeType: 0
      }
    }
  },
  provide: function () {
    return {
      baseInfo: this.baseInfo
    }
  },
  created () {
    this.getBaseInof()
    bus.$on('angentChange', res => {
      this.getBaseInof(true)
    })
  },
  beforeDestroy () {
    bus.$off('angentChange')
  },
  methods: {
    /*左边子组件传来的参数*/
    selectMenuFunc (param) {
      this.hasChild = param
    },

    async getBaseInof (force = false) {
      let res
      if (force) {
        res = await store.dispatch('common/forceGetBaseInfo')
      } else {
        res = await store.dispatch('common/getBaseInfo')
      }
      this.baseInfo.storeType = res.storeType || 0
      this.baseInfo.wxQrCode = res.wxQrCode || ''
      this.baseInfo.wxUrlLink = res.wxUrlLink || ''
      this.baseInfo.shop_name = res.shop_name
      this.baseInfo.version = res.version
      this.baseInfo.user = res.user
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/layout/main.vue